import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  list_item: {
    "&:hover": {
      backgroundColor: palette.primary.light,
    },
    backgroundColor: "white",
  },

  list_item__icon: {
    color: palette.grey["600"],
    marginLeft: spacing(0.5),
    marginRight: spacing(2.5),
    minWidth: spacing(3),
  },
}));
